export const getUrlDraftParam = (): string => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('draft') ? `draft=${urlParams.get('draft')}&` : '';
};
